import { render, staticRenderFns } from "./InvasiveDetails.vue?vue&type=template&id=251d43a7&scoped=true"
import script from "./InvasiveDetails.vue?vue&type=script&lang=js"
export * from "./InvasiveDetails.vue?vue&type=script&lang=js"
import style0 from "./InvasiveDetails.vue?vue&type=style&index=0&id=251d43a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251d43a7",
  null
  
)

export default component.exports